import { RequireAuthentication } from 'containers/RequireAuthentication';
import { AdminsLinksLoadable } from 'pages/AdminsLinks';
import { BuyCreditsLinksLoadable } from 'pages/BuyCreditsLinks';
import { CreditsLinksLoadable } from 'pages/CreditsLinks';
import { EditOrgLinksLoadable } from 'pages/EditOrgLinks';
import { GradFairsLinksLoadable } from 'pages/GradFairsLinks';
import { IntegrateAtsLinksLoadable } from 'pages/IntegrateAtsLinks';
import { InvoicesLinksLoadable } from 'pages/InvoicesLinks';
import { AppRouteObject } from 'routing/classes/types/AppRouteObject';

/**
 * A set of routes that use OrgDashboardOrgSelectionSubLayout
 *
 * These routes are separate in their own file to facilitate maintenance, and
 * they're used on `main.route-objects.tsx`
 */
export const orgSelectRouteObjects = [
  {
    path: '/buy-credits',
    element: (
      <RequireAuthentication>
        <BuyCreditsLinksLoadable />
      </RequireAuthentication>
    ),
  },
  {
    path: '/integrate-ats',
    element: (
      <RequireAuthentication>
        <IntegrateAtsLinksLoadable />
      </RequireAuthentication>
    ),
  },
  {
    path: '/credits',
    element: (
      <RequireAuthentication>
        <CreditsLinksLoadable />
      </RequireAuthentication>
    ),
  },
  {
    path: '/admins',
    element: (
      <RequireAuthentication>
        <AdminsLinksLoadable />
      </RequireAuthentication>
    ),
  },
  {
    path: '/edit-org',
    element: (
      <RequireAuthentication>
        <EditOrgLinksLoadable />
      </RequireAuthentication>
    ),
  },
  {
    path: '/gradfairs',
    element: (
      <RequireAuthentication>
        <GradFairsLinksLoadable />
      </RequireAuthentication>
    ),
  },
  {
    path: '/invoices',
    element: (
      <RequireAuthentication>
        <InvoicesLinksLoadable />
      </RequireAuthentication>
    ),
  },
] satisfies AppRouteObject[];
